export const updateFieldState = setStateHook => {
  // Input onChange handler which takes a useState setter
  // and calls it with the target value when input changes.
  return event => setStateHook(event.target.value);
};
